module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Pound-9dec635ca9cee8f27e1b55553df50c94.svg";